import { BarChart } from '@mui/icons-material';
import { AuthLayout } from '../components/AuthLayout/AuthLayout';
import { AuthPromoPanel } from '../components/AuthPromoPanel/AuthPromoPanel';
import { ForgotPasswordForm } from '../components/ForgotPasswordForm/ForgotPasswordForm';
import styles from './ForgotPasswordPage.module.css';

interface ForgotPasswordPageProps {
	userEmail?: string;
	onBack?: () => void;
}

export const ForgotPasswordPage = ({ userEmail, onBack }: ForgotPasswordPageProps) => {
	return (
		<AuthLayout
			title="Recuperar Senha"
			subtitle="Informe seu e-mail para receber o link de recuperação"
			logoClassName={styles.logo}
			headerClassName={styles.header}
			promoPanel={
				<AuthPromoPanel
					promoImageSrc="/images/login-promo-image.jpg"
					promoTitle="Alcance metas rápido"
					promoDescription="Utilize o Practium para fazer todo o controle fino da sua operação, atingindo suas metas para 2026"
					statsCard={{
						icon: <BarChart />,
						label: 'Faturamento',
						value: 'R$75 040',
					}}
					sectionHeading="Controle total da operação"
					sectionText="Tenha o controle total da sua operação na palma de suas mãos, acompanhando produção, custos, equipes e resultados em tempo real, tudo no Practium"
				/>
			}
		>
			<ForgotPasswordForm initialEmail={userEmail} onBack={onBack} />
		</AuthLayout>
	);
};
